import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import Icon from './Icons';
import './CustomToast.css';

const VARIANT_STYLES = {
  success: {
    background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.96) 0%, rgba(34, 211, 238, 0.92) 100%)',
    border: '1px solid rgba(14, 165, 233, 0.28)',
    boxShadow:
      '0 20px 40px rgba(14, 165, 233, 0.16), 0 10px 24px rgba(59, 130, 246, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.1)'
  },
  danger: {
    background: 'linear-gradient(135deg, rgba(219, 39, 119, 0.96) 0%, rgba(185, 28, 28, 0.94) 100%)',
    border: '1px solid rgba(219, 39, 119, 0.22)',
    boxShadow:
      '0 20px 40px rgba(219, 39, 119, 0.18), 0 10px 24px rgba(185, 28, 28, 0.14), 0 0 0 1px rgba(255, 255, 255, 0.1)'
  },
  warning: {
    background: 'linear-gradient(135deg, rgba(249, 115, 22, 0.96) 0%, rgba(234, 88, 12, 0.92) 100%)',
    border: '1px solid rgba(249, 115, 22, 0.24)',
    boxShadow:
      '0 20px 40px rgba(249, 115, 22, 0.16), 0 10px 24px rgba(234, 88, 12, 0.14), 0 0 0 1px rgba(255, 255, 255, 0.1)'
  },
  info: {
    background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.96) 0%, rgba(129, 140, 248, 0.92) 100%)',
    border: '1px solid rgba(59, 130, 246, 0.24)',
    boxShadow:
      '0 20px 40px rgba(59, 130, 246, 0.16), 0 10px 24px rgba(129, 140, 248, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.1)'
  }
};

const VARIANT_ICONS = {
  danger: 'exclamationTriangle',
  warning: 'exclamationCircle',
  success: 'checkCircle',
  info: 'infoCircle'
};

const VARIANT_TITLES = {
  danger: '❌ Erreur',
  warning: '⚠️ Attention',
  success: '✅ Succès',
  info: 'ℹ️ Info'
};

/**
 * Pile de toasts visuels alimentée par le hook `useToast`.
 *
 * @param {object} props
 * @param {Array<{ id: number, message: string, variant: string }>} props.toasts
 * @param {(id: number) => void} props.onRemove
 * @param {(variant: string) => number} props.getDuration
 */
const ToastStack = ({ toasts, onRemove, getDuration }) => {
  return (
    <ToastContainer className="custom-toast-container">
      {toasts.map((toast) => {
        const style = VARIANT_STYLES[toast.variant] || VARIANT_STYLES.info;
        const icon = VARIANT_ICONS[toast.variant] || VARIANT_ICONS.info;
        const title = VARIANT_TITLES[toast.variant] || VARIANT_TITLES.info;
        const durationSec = (getDuration?.(toast.variant) ?? 5000) / 1000;

        return (
          <Toast
            key={toast.id}
            onClose={() => onRemove(toast.id)}
            onClick={() => onRemove(toast.id)}
            show
            autohide={false}
            className={`custom-toast custom-toast-${toast.variant}`}
            style={style}
            role="alert"
          >
            <Toast.Header>
              <Icon name={icon} size={18} className="toast-icon" />
              <strong className="me-auto">{title}</strong>
            </Toast.Header>
            <Toast.Body>{toast.message}</Toast.Body>
            <div
              className="toast-progress-bar"
              style={{ animationDuration: `${durationSec}s` }}
            />
          </Toast>
        );
      })}
    </ToastContainer>
  );
};

export default ToastStack;
